import React from 'react';
import clsx from 'clsx';
import LeftIcon from '@material-ui/icons/ChevronLeft';
import RightIcon from '@material-ui/icons/ChevronRight';
import MessageIcon from '@material-ui/icons/Message';
import HeadsetIcon from '@material-ui/icons/Headset';
import { IconButton, Drawer, Divider, List, useTheme } from '@material-ui/core';
import { matchPath, useLocation } from 'react-router-dom';
import { NavBarProps } from 'models';
import { MESSAGES, PROGRAMS } from 'constants/routes';
import PrivateSwitch from 'components/mainComponents/RoutesSwitch/PrivateSwitch';
import useStyles from './style';
import MenuItem from './MenuItem';

const drawerItems = [
  {
    name: 'Inspirations',
    path: MESSAGES,
    icon: <MessageIcon />,
    selected: <MessageIcon className='selected-drawer' />,
  },
  {
    name: 'Programs',
    path: PROGRAMS,
    role: 'all',
    icon: <HeadsetIcon />,
    selected: <HeadsetIcon className='selected-drawer' />,
  },
];

const LeftMenu: React.FC<NavBarProps> = (props) => {
  const { isOpen, onClick } = props;
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();

  const handleDrawerState = (): void => {
    onClick();
  };

  return (
    <>
      <Drawer
        variant='permanent'
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: isOpen,
            [classes.drawerClose]: !isOpen,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerState}>
            {theme.direction === 'rtl' ? <RightIcon /> : <LeftIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          {drawerItems.map((item) => (
            <MenuItem
              key={item.name}
              name={item.name}
              path={item.path}
              icon={
                matchPath(location.pathname, { path: item.path })
                  ? item.selected
                  : item.icon
              }
            />
          ))}
        </List>
      </Drawer>
      <PrivateSwitch />
    </>
  );
};

export default LeftMenu;
